module.exports = __webpack_public_path__ + "static/media/avatar-13.b8fa52ec.svg";